import { Observable } from 'rxjs/Observable';
import { Called } from '../_models/called';
import { Injectable, EventEmitter } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';

@Injectable()
export class CalledsService {

  private calledsCollection: AngularFirestoreCollection<Called>;

  eventSelectCalled: EventEmitter<Called> = new EventEmitter<Called>();

  constructor(
    private _firestore: AngularFirestore
  ) { }

  /**
   * Retorna todos os chamados
   */
  getCalleds(): Observable<Called[]> {

    this.calledsCollection = this._firestore.collection<Called>('calleds', ref =>
      ref
        .orderBy('date', 'desc')
    );

    return this.calledsCollection.snapshotChanges().map(o => {
      return o.map(item => {
        const data = item.payload.doc.data();
        const uuid = item.payload.doc.id;

        if (data.date) {
          if (typeof data.date.toDate === 'function') {
            data.date = data.date.toDate();
          }
        }

        return new Called({ ...{ uuid: uuid }, ...data });
      });
    });

  }

  /**
   * Método para inserir chamado
   * @param called
   */
  insertCalled(called: Called) {
    return this._firestore
      .collection('calleds')
      .add(called.toFirebase());
  }

  /**
   * Método para selecionar um chamado
   * @param called
   */
  selectCalled(called: Called): void {
    this.eventSelectCalled.emit(called);
  }

}
